import React from 'react';
import { RowMd7 } from 'app/blocks/blocks';
import withScrollToContent from 'app/blocks/common/withScrollToContent';

function OrdersPayment() {
    return (
        <RowMd7>
            <div className="loading-img" />
        </RowMd7>
    );
}

export default withScrollToContent(OrdersPayment);
